import React, { useEffect, useRef, useState } from 'react';
import styles from './SuperSearch.module.css';
import isNull from "../../../utils/NullChecking";
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import { enumUtil } from '../../../utils/Enum';
import InitialLetters from "../../../utils/InitialLetters";
import { useSelector } from 'react-redux';
import { isFemale, isMale } from '../../../utils/Gender';

const SuperSearchMultiple = (props) => {
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  const isHomeCareCheck = DropDowns.IsHomeCare;
  const { optionss, onSelect, initialSelectedValues, initialSelectedOptionsInstant, name, Design, clear, setClear } = props; // Destructure onSelect from props
  const [initialSelectedItemIndex, setInitialSelectedItemIndex] = useState(-1);
  const [isItemSelected, setisItemSelected] = useState(false)
  // const [oldValue, setOldValue] = useState('');
  const [selectedData, setSelectedData] = useState(0);
  const [selectedOptions, setSelectedOptions] = useState(initialSelectedValues);
  const [selectedOptionsInstant, setSelectedOptionsInstant] = useState(initialSelectedOptionsInstant || []);

  const [searchTerm, setSearchTerm] = useState('');
  const [instantTerm, setInstantTerm] = useState('');

  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(optionss);
  const [filteredInstentOption, setfilteredInstentOption] = useState([]);

  const [isListOpen, setIsListOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [buttonWidth, setButtonWidth] = useState(0)
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [noResult, setNoResult] = useState(false);
  const [noResponse, setNoResponse] = useState([]);

  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    if (clear && clear === true) {
      if (props.type === 'server') {
        setSelectedOptionsInstant([])

      }
      else {
        setSelectedOptions([])
      }
    }
    return () => {
      if (props.setClear) {
        setClear(false)
      }
    };
  }, [clear])
  useEffect(() => {
    const filteredItems = optionss?.filter(item => item.value !== -1);
    setFilteredOptions(filteredItems);
  }, [])
  useEffect(() => {
    if (props.type === 'server' && searchTerm.length > 2) {
      const abortController = new AbortController();
      setIsLoading(true);
      ServerRequestProtected(props.controller + props.ApiLink, props.method, {
        "TableName": props.tableName,
        "SearchParam": searchTerm,
      }, abortController.signal
      ).then((response) => {
        setIsLoading(false);
        setNoResponse(response);
      }).catch((error) => {
        setNoResponse([]);
        setIsLoading(false);
        // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
      });
      return () => { abortController.abort(); };
    }
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsListOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    getWidth();
    if (inputRef3.current) {
      inputRef3.current.focus();
    }
  }, [selectedOptions, selectedOptionsInstant]);
  let data = []
  let datainstant = []
  // const handleToggleOption = (option) => {
  //   ResetOption()
  //   const isSelected = selectedOptions.some((selected) => selected.value === option.value);
  //   if (isSelected) {
  //     data = selectedOptions.filter((selected) => selected.value !== option.value)
  //     setSelectedOptions(data)
  //     // setSelectedOptions(selectedOptions.filter((selected) => selected.value !== option.value));
  //     const index = filteredOptions.findIndex((filteredOption) => filteredOption.value === option.value);
  //     setSelectedIndices((prevIndices) => {
  //       const indexInArray = prevIndices.indexOf(index);
  //       if (indexInArray !== -1) {
  //         return prevIndices.filter((idx) => idx !== index);
  //       } else {
  //         return [...prevIndices, index];
  //       }
  //     });
  //   } else {
  //     if (selectedOptions.length < 3) {
  //       data = [...selectedOptions, option]
  //       setSelectedOptions(data);
  //       // const index = filteredOptions.findIndex((filteredOption) => filteredOption.value === option.value);

  //       // setSelectedIndices((prevIndices) => {
  //       //   const indexInArray = prevIndices.indexOf(index);
  //       //   if (indexInArray !== -1) {
  //       //     return prevIndices.filter((idx) => idx !== index);
  //       //   } else {
  //       //     return [...prevIndices, index];
  //       //   }
  //       // });
  //     } else {
  //       console.log('cannot add more than 3');
  //     }
  //   }
  //   onSelect(data, "client", name);

  // };
  const handleToggleOption = (option) => {
    // debugger
    // setSearchTerm('');
    ResetOption()
    const isSelected = selectedOptions.some((selected) => selected.value === option.value);
    if (isSelected) {
      data = selectedOptions.filter((selected) => selected.value !== option.value)
      setSelectedOptions(data)
      // setSelectedOptions(selectedOptions.filter((selected) => selected.value !== option.value));

      const index = filteredOptions.findIndex((filteredOption) => filteredOption.value === option.value);
      setSelectedIndices((prevIndices) => {
        const indexInArray = prevIndices.indexOf(index);
        if (indexInArray !== -1) {
          return prevIndices.filter((idx) => idx !== index);
        } else {
          return [...prevIndices, index];
        }
      });
    } else {
      // if (selectedOptions.length < 3) {
      data = [...selectedOptions, option]
      setSelectedOptions(data);
      const index = filteredOptions.findIndex((filteredOption) => filteredOption.value === option.value);
      setSelectedIndices((prevIndices) => {
        const indexInArray = prevIndices.indexOf(index);
        if (indexInArray !== -1) {
          return prevIndices.filter((idx) => idx !== index);
        } else {
          return [...prevIndices, index];
        }
      });
      // } 
      // else {
      // }
    }
    onSelect(data, "client", name);

  };
  const handleToggleOptionsforInstant = (option) => {
    setSearchTerm('');
    ResetOptionInstant();
    const isSelected = selectedOptionsInstant.some((selected) => selected.value === option.value);
    if (isSelected) {
      datainstant = selectedOptionsInstant.filter((selected) => selected.value !== option.value)
      setSelectedOptionsInstant(datainstant)
      // setSelectedOptionsInstant(selectedOptionsInstant.filter((selected) => selected.value !== option.value));
      const index = filteredInstentOption.findIndex((filteredOption) => filteredOption.value === option.value);
      setSelectedIndices((prevIndices) => {
        const indexInArray = prevIndices.indexOf(index);
        if (indexInArray !== -1) {

          return prevIndices.filter((idx) => idx !== index);
        } else {
          return [...prevIndices, index];
        }

      });
    } else {
      // if (selectedOptionsInstant.length < 3) {
      datainstant = [...selectedOptionsInstant, option]
      setSelectedOptionsInstant(datainstant)
      // setSelectedOptionsInstant([...selectedOptionsInstant, option]);
      const index = filteredInstentOption.findIndex((filteredOption) => filteredOption.value === option.value);
      setSelectedIndices((prevIndices) => {
        const indexInArray = prevIndices.indexOf(index);
        if (indexInArray !== -1) {
          return prevIndices.filter((idx) => idx !== index);
        } else {
          return [...prevIndices, index];
        }
      });
      // } else {
      //   console.log('cannot add more than 3');
      // }
    }
    onSelect(datainstant, "server", name);

  };


  const handleRemoveOption = (selected, index) => {
    let data = []
    ResetOption()
    if (selectedIndices.length > 0) {
      const indexToRemove = index
      const optionToRemove = selected
      data = selectedOptions?.filter((selected) => selected?.value !== optionToRemove?.value)
      setSelectedOptions(data)
      // Remove the index from selectedIndices
      setSelectedIndices((prevIndices) => prevIndices.filter((index) => index !== indexToRemove));

      onSelect(data, "client", name)

    }


  };

  const handleRemoveOptioninstant = (selected, index) => {

    let data = []
    ResetOptionInstant()
    if (selectedOptionsInstant.length > 0) {
      const indexToRemove = index // selectedIndices[selectedIndices.length - 1];
      const optionToRemove = selected
      //  filteredOptions[indexToRemove];

      // Remove the selected option
      // setSelectedOptionsInstant((prevSelectedOptions) =>
      //  data =   prevSelectedOptions?.filter((selected) => selected?.value !== optionToRemove?.value)
      // );

      data = selectedOptionsInstant?.filter((selected) => selected?.value !== optionToRemove?.value)
      setSelectedOptionsInstant(data)

      // Remove the index from selectedIndices
      setSelectedIndices((prevIndices) => prevIndices.filter((index) => index !== indexToRemove));

      onSelect(data, "server", name)
    }


  };
  const handleSearch = (event) => {
    const term = event.target.value;

    if (!isNull(term)) {
      setSearchTerm(term);
      const filtered = optionss.filter((option) =>
        option.display?.toLowerCase().includes(term.toLowerCase())
      );
      setFilteredOptions(filtered);
    } else {
      setSearchTerm(term)
      setFilteredOptions(optionss);
      setNoResponse([])   // removeing 
    }

  };
  // const handleinstantsearch = (event) => {
  //   const instntterm = event.target.value;
  //   setInstantTerm(instntterm);

  //   if (!isNull(instntterm)) {
  //     const filtered = noResponse.filter((option) =>
  //       option.display.toLowerCase().includes(instntterm.toLowerCase())
  //     );
  //     setfilteredInstentOption(filtered);
  //   } else {
  //     setInstantTerm(instntterm)
  //     setfilteredInstentOption(noResponse);
  //   }

  // };
  const ResetOption = () => {
    setSearchTerm('')
    setFilteredOptions(optionss)
    handleSpanClick()
  }
  const ResetOptionInstant = () => {
    setSearchTerm('')
    setNoResponse([])
    if (props?.SuperSearchView === "DetailedView") {
      handleSpanClick();
    }
  }
  const handleKeyDown = (event) => {
    if (isListOpen) {
      // if (event.key === 'ArrowDown') {
      //   // setHighlightedIndex((prevIndex) =>
      //   //   prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : prevIndex
      //   // );
      //   setSelectedIndices((prevIndices) => {
      //     const nextIndex = prevIndices.length > 0 ? prevIndices[prevIndices.length - 1] + 1 : 0;
      //     return [...prevIndices, nextIndex];
      //   });
      // } else if (event.key === 'ArrowUp') {
      //   // setHighlightedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
      //   setSelectedIndices((prevIndices) => {
      //     if (prevIndices.length === 0) return prevIndices;
      //     const lastSelected = prevIndices[prevIndices.length - 1];
      //     const nextIndex = lastSelected > 0 ? lastSelected - 1 : 0;
      //     return [...prevIndices, nextIndex];
      //   });
      // } else 
      if (event.key === 'Enter') {
        // Handle selection on Enter key press
        // if (highlightedIndex !== -1) {
        //   handleToggleOption(filteredOptions[highlightedIndex]);
        // }
        if (selectedIndices.length > 0) {
          if (props?.SuperSearchView !== "DetailedView") {
            handleToggleOption(filteredOptions[selectedIndices[selectedIndices.length - 1]]);
          }
        }
      } else if (event.key === 'Backspace') {
        if (props.type === 'client') {
          if (searchTerm !== '') {
            // let remove = searchTerm.slice(0, -1); 
            // let remove =searchTerm.substring(0, searchTerm.length-1)
            // setSearchTerm(remove)
          }
          else {
            if (selectedOptions && selectedOptions.length > 0) {
              handleToggleOption(selectedOptions[selectedOptions.length - 1])
            }
          }
        }
        else {
          if (searchTerm !== '') {
            // let remove = searchTerm.slice(0, -1); 
            // let remove =searchTerm.substring(0, searchTerm.length-1)
            // setSearchTerm(remove)
          }
          else {
            if (selectedOptionsInstant && selectedOptionsInstant.length > 0) {
              handleToggleOptionsforInstant(selectedOptionsInstant[selectedOptionsInstant.length - 1])
            }
          }

        }


      }
    };
  }
  useEffect(() => {
    // Automatic scrolling
    if (listRef.current && highlightedIndex !== -1) {
      handleScroll(highlightedIndex);
    }
  }, [highlightedIndex]);

  const handleScroll = (index) => {
    const list = listRef.current;
    if (list) {
      const listItems = list.querySelectorAll('#ul-list-for-auto li');
      if (listItems && listItems[index]) {
        const selectedElement = listItems[index];
        list.scrollTop = selectedElement.offsetTop - list.offsetTop;
      }
    }
  };
  const handleOptionClick = (option) => {
    handleToggleOption(option);
    // setHighlightedIndex(-1);
  };
  const getWidth = () => {
    setButtonWidth(buttonRef.current.offsetWidth + 10)
  };
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRefOld = useRef(null);
  // Function to handle the span click and move focus to the input field
  const handleSpanClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handleSpanClickOLD = () => {
    if (inputRefOld.current) {
      inputRefOld.current.focus();
    }
  };

  let counter = initialSelectedItemIndex != -1 ? initialSelectedItemIndex : 0; // to maintain the index 
  let bool;  // to check if the arrow is changed from down to up or from up to down (so we should inc or dec)
  let lastKeyPressed; // to check weather counter should be incremented or decremented
  const onKeyDownPressed = (e) => {
    if (e.keyCode === 40) {   // onDownkeyPress
      // debugger
      if (bool === false) {
        counter = counter + 2
      }
      handleScroll(counter);
      lastKeyPressed = e.keyCode
      if (noResponse[counter] !== undefined) {
        if (counter <= noResponse.length) {
          const listItems = document.querySelectorAll('#ul-list-for-auto li');
          listItems.forEach(function (item, index) {
            if (index === counter) {
              item.classList.add(styles.sup_DU);
            } else {
              item.classList.remove(styles.sup_DU);
            }
          });
          counter = counter + 1
          bool = true
        }
      }
    }
    if (e.keyCode === 38) {
      // onUpkeyPress
      if (bool === true) {
        counter = counter - 2
      }
      handleScroll(counter);
      lastKeyPressed = e.keyCode
      if (noResponse[counter] !== undefined) {
        if (counter <= noResponse.length) {
          const listItems = document.querySelectorAll('#ul-list-for-auto li');
          listItems.forEach(function (item, index) {
            if (index === counter) {
              item.classList.add(styles.sup_DU);
            } else {
              item.classList.remove(styles.sup_DU);
            }
          });
          counter = counter - 1
        }
        bool = false
      }
    }
    if (e.keyCode === 13) // User pressed the ENTER key
    {
      setisItemSelected(true)
      let index = counter;
      if (lastKeyPressed === 40) {
        index = index - 1  // onDownkeyPress
      } else if (lastKeyPressed === 38) {
        index = index + 1  // onUpkeyPress
      }
      if (noResponse.length > 0) {
        handleToggleOptionsforInstant(noResponse[index]);
        // setIsListOpen(false);
        // setFilteredOptions([]);
        // setOldValue(options[index].display)
        // setNoResult(false)
        // setOptions([])
      } else {
        // handleonBlur(e)
      }
      // handleScroll(counter);
    }
    if (e.keyCode === 27) { // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
      props.getSelectedData(null)
      setOptions([])
      setNoResult(!noResult)
      setSelectedData(0);
    }
  }
  return (
    <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ${Design === 'New' ? "ar-options-list" : ""} `} ref={wrapperRef} onKeyDown={handleKeyDown}>
      {/* For Server */}
      {props.type === "server" ?
        Design === 'New' ?
          <div className={'selected_options'} ref={buttonRef}>
            {selectedOptionsInstant?.slice(0, 2).map((selected, index) => (
              <p className='text options' key={index} onClick={handleSpanClick}>{selected?.display}</p>
            ))}
            {selectedOptionsInstant?.length > 2 ? <span className='heading orange-clr ms-2' onClick={handleSpanClick}>+{selectedOptionsInstant?.length - 2}</span> : <></>}
          </div> :
          /* SuperSearchMultiple for Detailed View */
          /* Multi select input in case of more than 1 record */
          props?.SuperSearchView === "DetailedView" ?
            <div className={`selected_options  server-scroll d-flex align-items-center justify-content-between detailed_view ${selectedOptionsInstant.length === 0 ? "d-none" : ""}`} ref={buttonRef}>
              <div className='d-flex align-items-center'>
                {selectedOptionsInstant?.map((selected, index) => (
                  <div className='d-flex align-items-center ar-selected' >
                    <p className='text fs-10 font-m validation_message text-nowrap'>
                      {selected?.display}
                    </p>
                    <i className="icon-Group-3311" onClick={() => handleRemoveOptioninstant(selected, index)}></i>
                  </div>
                ))}
                <div className={`input ${selectedOptionsInstant?.length === 1 ? 'width' : ''}`}>
                  <input
                    ref={inputRef3}
                    value={searchTerm}
                    onChange={handleSearch}
                    onClick={() => { setIsListOpen(true); }}
                    className='form-control'
                    onKeyDown={(e) => {
                      onKeyDownPressed(e);
                    }}
                  />
                </div>
              </div>
              <i className="icon-lite-cross fs-16" onClick={() => { setSelectedOptionsInstant([]); setSearchTerm(''); setFilteredOptions([]); setNoResponse([]) }}></i>
            </div> :
            <div className={'selected_options  server-scroll'} ref={buttonRef}>
              {selectedOptionsInstant?.map((selected, index) => (
                <div className='d-flex align-items-center ar-selected' >
                  <p className='text text-white validation_message text-nowrap'>
                    {selected?.display}
                  </p>
                  <i className="bi bi-x text-white" onClick={() => handleRemoveOptioninstant(selected, index)}></i>
                </div>
              ))}
            </div>
        /* For Client */
        : props.type === 'client' ?
          Design === 'New' ?
            <div className={'selected_options'} ref={buttonRef}>
              {selectedOptions?.slice(0, 2).map((selected, index) => (
                <p className='text options' key={index} onClick={handleSpanClick}>{selected?.display}</p>
              ))}

              {selectedOptions.length > 2 ? <span className='heading orange-clr ms-2' onClick={handleSpanClick}>+{selectedOptions?.length - 2}</span> : <></>}
            </div> :
            <div className={'selected_options server-scroll'} ref={buttonRef}>
              {selectedOptions?.map((selected, index) => (
                <div className='d-flex align-items-center ar-selected' >
                  <p className='text text-white validation_message text-nowrap'>
                    {selected?.display}
                  </p>
                  <i className="bi bi-x text-white" onClick={() => handleRemoveOption(selected, index)}></i>
                </div>

              ))}
            </div> : null}
      {/* For Client */}
      {props.type === 'client' ?
        Design === "New" ? (
          <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ar-options-list`} ref={wrapperRef} onKeyDown={handleKeyDown}>
            <div className={`input-group ar-search-arrow ${styles[props.sup_inp]}`} >
              <input
                style={{ paddingLeft: buttonWidth }}
                value={searchTerm}
                onChange={handleSearch}
                onFocus={() => setIsListOpen(true)}
                ref={inputRef}
              />
              {isListOpen ? <i className='icon-caret-up' onClick={() => setIsListOpen(!isListOpen)}></i> : <i className='icon-caret-down' onClick={() => setIsListOpen(!isListOpen)}></i>}

              {isListOpen && (
                <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4`} >
                  <ul className="list-group" id="ul-list-for-auto">
                    {filteredOptions?.map((option, index) => {
                      return (
                        <li
                          className={`d-flex align-items-center gap-1 ${styles.sup_list_group_item} ${selectedOptions?.some(op => op.value === option.value) ? styles.sup_DU : ''}`}
                          key={option.value}
                          onClick={() => { handleToggleOption(option) }}>
                          <i className={`icon-check ${selectedOptions?.some(op => op.value === option.value) ? 'opacity-100' : 'opacity-0'}`}></i>
                          <p className='ms-1 text'>{option.display}</p>
                        </li>
                      );
                    })}

                  </ul>
                </div>
              )}
            </div>
          </div>) : (
          <div className={`input-group ar-multiple-br ${styles[props.sup_inp]}`}>
            <input
              style={{ paddingLeft: buttonWidth }}
              // placeholder="Search..." 
              value={searchTerm}
              onChange={handleSearch}
              onClick={() => setIsListOpen(!isListOpen)}
            />
            <div className="search-arrow" onClick={() => setIsListOpen(true)} tabIndex={0}>
              {isListOpen ? (<span className="dropdown_icon position-absolute top-0 end-1 up" onClick={() => setIsListOpen(true)} ><i class="icon-caret-up"></i></span>)
                :
                (<span className="dropdown_icon position-absolute top-0 end-1" onClick={() => setIsListOpen(true)}><i class="icon-caret-down"></i></span>)}
            </div>
            {isListOpen && (
              <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4`} >
                <ul className="list-group" id="ul-list-for-auto">
                  {filteredOptions?.map((option, index) => (
                    <li
                      className={`${styles.sup_list_group_item} ${selectedOptions?.includes(option) ? styles.sup_DU : ''}`}
                      key={option.value}
                      onClick={() => { handleToggleOption(option) }}>
                      {option.display}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>)
        :
        /* For Server */
        props.type === 'server' ?
          Design === 'New' ?
            <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto} ar-options-list`} ref={wrapperRef} onKeyDown={handleKeyDown}>
              <div className={`input-group ar-search-arrow ${styles[props.sup_inp]}`} >
                <input
                  style={{ paddingLeft: buttonWidth }}
                  value={searchTerm}
                  onChange={handleSearch}
                  // onClick={() => setIsListOpen(!isListOpen)}
                  onFocus={() => setIsListOpen(true)}
                  ref={inputRef}
                // onBlur={handleonBlur}
                />
                {isListOpen ? <i className='icon-caret-up' onClick={() => setIsListOpen(!isListOpen)}></i> : <i className='icon-caret-down' onClick={() => setIsListOpen(!isListOpen)}></i>}
                {/* <i className='icon-caret-up'></i>
          <i className='icon-caret-down'></i> */}

                {isListOpen && (
                  <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4`} >
                    <ul className="list-group" id="ul-list-for-auto">
                      {noResponse?.map((option, index) => {
                        return (
                          <li
                            className={`d-flex align-items-center gap-1 ${styles.sup_list_group_item} ${selectedOptionsInstant?.some(op => op.value === option.value) ? styles.sup_DU : ''}`}
                            key={option.value}
                            onClick={() => { handleToggleOptionsforInstant(option) }}>
                            <i className={`icon-check ${selectedOptions?.some(op => op.value === option.value) ? 'opacity-100' : 'opacity-0'}`}></i>
                            <p className='ms-1 text'>{option.display}</p>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            </div> :
            props?.SuperSearchView === "DetailedView" ?
              /* SuperSearchMultiple for Detailed View */
              // input incase of no record selected
              <div className={`input-group ${styles[props.sup_inp]}`}>
                <input
                  ref={inputRef2}
                  value={selectedOptionsInstant?.length > 0 ? "" : searchTerm}
                  onChange={handleSearch}
                  onClick={() => setIsListOpen(true)}
                  placeholder={`${selectedOptionsInstant.length === 0 ? "Type 3 or more characters to search..." : ""}`}
                  onKeyDown={(e) => {
                    onKeyDownPressed(e);
                    // handleCommonKeyDown(e);
                  }}
                />
                <div className="search-arrow">
                  <span className="dropdown_icon position-absolute top-0 end-1 detailed">
                    <i className='icon-Clip-path-group fs-15'></i>
                  </span>
                </div>
                {/* SuperSearchMultiple for Detailed Patient View*/}
                {props?.DetailedView === "Patient" ?
                  <>
                    {isListOpen ?
                      (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                        <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{noResponse?.length || '0'} Result(s) Found</p>
                        <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                          {noResponse?.length > 0 ?
                            (noResponse?.map((option, index) => (
                              <li className={`za-supercard za-br-tb ${selectedOptionsInstant.map(item => item.value)?.includes(option.value) ? styles.sup_DU : ''}`}
                                key={option.value}
                                onClick={() => { handleToggleOptionsforInstant(option); }}
                                id={index}>
                                {props?.DetailedView === "Patient" ?
                                  <>
                                    <div className='d-flex gap-1 align-items-center'>
                                      <div className="circle img-container s-40">
                                        <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(option.Gender) ? 'za-male' : isFemale(option.Gender) ? 'za-female' : 'za-others'}`}>
                                          <InitialLetters classes={""} name={option.display} splitBy={','} />
                                        </p>
                                      </div>
                                      <div className='w-100 overflow-hidden'>

                                        <div className='d-flex align-items-center'>

                                          <div className='d-flex align-items-center gap-1 col-md-8'>
                                            {/* <span class="icon-searchlist-sumry fs-13"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                            <SearchLetterHighlighted searchValue={searchTerm} text={option.display} />
                                            <p className='text fs-11 ar-light-color'>{option.DOB} </p>
                                            <p className='text fs-11 ar-light-color'>{option.Age ? <>({option.Age})</> : <></>}</p>
                                            <p className={'text fs-11 ar-light-color'} >{option.Gender}</p>
                                          </div>
                                          <div className="col-md-4 text-end pe-1">
                                            <p className='text fs-12 fst-italic font-m ar-light-color'>{option.AccountNumber}</p>
                                          </div>
                                        </div>


                                        <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p>
                                        <div className='d-flex align-items-center'>
                                          {option.SubscriberID ?
                                            <div className='d-flex gap-1 col-md-6'>
                                              <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                              <p className='text fs-11 text-nowrap validation_message' title={option.SubscriberID}>{option.SubscriberID}</p>
                                            </div> : <></>}

                                          {isHomeCareCheck ?
                                            <>
                                              {option.MedicAidNo ?
                                                <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                                  <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                                  <p className='text fs-11 font-m text-nowrap validation_message' title={option.MedicAidNo}>{option.MedicAidNo}</p>
                                                </div> : <></>}
                                            </>
                                            : <></>}
                                        </div>

                                      </div>
                                    </div>

                                  </> : <></>}
                              </li>
                            ))) :
                            <div className='d-flex gap-01'>
                              <div className="list-group w-100" id="ul-list-for-auto">
                                <p className={styles.sup_list_group_item} >No Data Found !</p>
                              </div>
                            </div>}
                        </ul>
                      </div>) : <></>}
                  </> : <></>}
              </div> :
              <div className={`input-group ${styles[props.sup_inp]}`}>
                <input
                  style={{ paddingLeft: buttonWidth }}
                  // placeholder="Search..." 
                  value={searchTerm}
                  onChange={handleSearch}
                  onClick={() => setIsListOpen(!isListOpen)}
                />
                <div className="search-arrow" onFocus={() => setIsListOpen(false)} tabIndex={0}>
                  {isListOpen ? (<span className="dropdown_icon position-absolute top-0 end-1 up" onClick={() => setIsListOpen(true)} ><i class="icon-caret-up"></i></span>)
                    : (<span className="dropdown_icon position-absolute top-0 end-1" onFocus={() => setIsListOpen(false)}><i class="icon-caret-down"></i></span>)}
                </div>

                {isListOpen && (
                  <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4`} >
                    <ul className="list-group" id="ul-list-for-auto">
                      {noResponse?.map((option, index) => (
                        <li
                          className={`${styles.sup_list_group_item} ${selectedOptionsInstant.some(op => op.value === option.value) ? styles.sup_DU : ''}`}
                          key={option.value} onClick={() => { handleToggleOptionsforInstant(option) }}
                        >
                          {option.display}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
          : null
      }
    </div >



  );
};
export default SuperSearchMultiple;

export const SearchLetterHighlighted = ({ text, searchValue }) => {
  const highlightText = (text, search) => {
    if (!search.trim()) return [text]; // Return original text as a single segment if search is empty

    // Escape special regex characters in the search string
    const escapedSearch = escapeRegExp(search);
    const regex = new RegExp(`(${escapedSearch})`, 'gi'); // Case-insensitive matching

    return text?.split(regex)?.map((part, index) =>
      regex.test(part) ? <span className='orange-clr' key={index}>{part}</span> : part
    );
  };

  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special characters
  };

  const segments = highlightText(text, searchValue);

  return (
    <p className='heading text-nowrap validation_message' title={text}>
      {segments}
    </p>
  );
}